import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';
import styles from './EmptyState.module.css';

export function EmptyState({
  title,
  description,
  children,
  className,
  dataTestId
}: {
  title: string;
  description?: string;
  children?: ReactNode;
  className?: string;
  dataTestId?: string;
}) {
  return (
    <div data-testid={dataTestId} className={cn(styles.root, className)}>
      <h2 className={styles.title}>{title}</h2>
      {description ? <p className={styles.description}>{description}</p> : null}
      {children}
    </div>
  );
}
